<dx-popup
  id="dialog-selection-plc"
  width="auto"
  height="auto"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [showCloseButton]="false"
  [wrapperAttr]="{ class: 'produit-complementaire-selection-plc-popup' }"
  (onShowing)="onShowing()"
  (onHiding)="onHiding()"
  [(visible)]="visible">

  <div *dxTemplate="let _ of 'title'" class="produit-complementaire-selection-plc-header">
    <div>
      <yo-icon icon="truck"></yo-icon> <strong> Choisir des points de livraison</strong>
      <span class="produit-complementaire-selection-plc-produit">{{ produitLibelle() }}</span>
    </div>

    <div class="produit-complementaire-selection-plc-header-actions">
      <yo-button
        iconClass="fas fa-check"
        tooltip="Valider la sélection"
        [theme]="ButtonThemeEnum.VALIDATE"
        (onClick)="valider()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Annuler"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="fermer()">
      </yo-button>
    </div>
  </div>

  <section class="produit-complementaire-selection-plc-content">
    <div class="produit-complementaire-selection-plc-barre-outils">
      <dx-text-box
        mode="search"
        placeholder="Rechercher un point de livraison, un code ou un client"
        valueChangeEvent="change"
        [width]="360"
        (onValueChanged)="onSearchChanged($event)">
      </dx-text-box>
      <span class="produit-complementaire-compteur">{{ currentPlcIdList().length }} sélectionné(s) sur {{ plcAssociableTotal() }}</span>
    </div>

    <dx-data-grid
      class="produit-complementaire-selection-plc-grid"
      [dataSource]="plcAssociableList()"
      keyExpr="plcId"
      [showBorders]="true"
      [showRowLines]="true"
      [hoverStateEnabled]="true"
      [selectedRowKeys]="currentPlcIdList()"
      (onSelectionChanged)="onSelectionChanged($event)"
      height="100%"
      noDataText="Aucun point de livraison associable">

      <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
      <dxo-sorting mode="single" showSortIndexes="false"></dxo-sorting>
      <dxo-paging [enabled]="false"></dxo-paging>

      <dxi-column dataField="plcCode" caption="Code" [width]="120" [allowSorting]="true"></dxi-column>

      <dxi-column dataField="plcLibelle" caption="Point de livraison"
                  [allowSorting]="true"
                  sortOrder="asc">
      </dxi-column>

      <dxi-column dataField="clientLibelle" caption="Client" [allowSorting]="true"></dxi-column>
    </dx-data-grid>

    <dx-pagination
      class="produit-complementaire-selection-plc-pager"
      [pageSize]="PAGE_SIZE"
      [itemCount]="plcAssociableTotal()"
      [pageIndex]="plcAssociablePage()"
      (pageIndexChange)="onPageIndexChange($event)"
      [showInfo]="true"
      [showNavigationButtons]="true"
      [showPageSizeSelector]="false"
      infoText="Page {0} sur {1}">
    </dx-pagination>
  </section>
</dx-popup>
